import { preloadDrumSamples } from './drumSamples';
import {
  playBoomwhackerSample,
  preloadBoomwhackerSamples,
  previewBoomwhackerSample,
} from './boomwhackerSamples';
import { unlockCelestialPad } from './celestialPadEngine';
import { getAudioContext } from './webAudioEngine';
import type { NoteId } from '../types';

export async function resumeAudio(): Promise<void> {
  await getAudioContext();
  await Promise.all([preloadBoomwhackerSamples(), preloadDrumSamples(), unlockCelestialPad()]);
}

export function playNote(note: NoteId, durationMs: number): void {
  if (note === 'rest') return;
  playBoomwhackerSample(note, durationMs);
}

export function previewNote(note: NoteId): void {
  if (note === 'rest') return;
  previewBoomwhackerSample(note);
}
